
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://eqlcfmracvaxaqzobajb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVxbGNmbXJhY3ZheGFxem9iYWpiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA4NTMxOTYsImV4cCI6MjA1NjQyOTE5Nn0.mlHsFmRYxCGL6uYncw7CTAmazaKEL_ENN4NtJmFd0bQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
